export default __webpack_public_path__ + "static/1-8f8c42bf727ef19a10b258544519ca8a.svg";